import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { ProjectSettingsForm } from "@/forms/project-settings-form";
import type { ProjectPanelBaseProps } from "../../types";
import { DeleteProject } from "./delete-project";
import { MergeProject } from "./merge-project";

export function ProjectSettingsGeneral({ projectId }: ProjectPanelBaseProps) {
	/** Render */
	return (
		<div className="v-stack">
			<ProjectSettingsForm
				scope="project"
				projectId={projectId}
			/>
			<ContentCard
				title="Danger Zone"
				icon={icon("Skull")}
			>
				<MergeProject projectId={projectId} />
				<DeleteProject projectId={projectId} />
			</ContentCard>
		</div>
	);
}
